'use client';

import { useEffect, useState } from 'react';
import { useParams, Navigate } from 'react-router-dom';
import { getInsightById } from '@/lib/actions/insights';
import { getFootprints } from '@/lib/actions/footprints';
import { getServiceCategories } from '@/lib/actions/service-categories';
import { InsightForm } from '@/components/admin/insights/InsightForm';

export default function AdminInsightEditPage() {
  const { id } = useParams<{ id: string }>();
  const [insight, setInsight] = useState<Awaited<ReturnType<typeof getInsightById>>>(null);
  const [footprints, setFootprints] = useState<Awaited<ReturnType<typeof getFootprints>>>([]);
  const [serviceCategories, setServiceCategories] = useState<Awaited<ReturnType<typeof getServiceCategories>>>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!id) return;
    Promise.all([getInsightById(id), getFootprints(), getServiceCategories()]).then(
      ([insightData, footprintsData, categoriesData]) => {
        setInsight(insightData);
        setFootprints(footprintsData);
        setServiceCategories(categoriesData);
        setLoading(false);
      }
    );
  }, [id]);

  if (loading) {
    return null;
  }

  if (!insight) {
    return <Navigate to="/admin/insights" replace />;
  }

  return (
    <InsightForm
      initialData={insight}
      allFootprints={footprints}
      serviceCategories={serviceCategories}
    />
  );
}
